---
title: 'Step 4: Configure the Collector'
install_track_title: Installation Guide (Neon)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx'

export const APIKeyInstructions = ({ apiKey }) => {
  return apiKey ? (
    <React.Fragment>
      The <code>PGA_API_KEY</code> for the current organization is{" "}
      <code>{apiKey}</code>
    </React.Fragment>
  ) : (
    <React.Fragment>
      The <code>PGA_API_KEY</code> can be found in the pganalyze Settings page
      for your organization, under the API Access tab
    </React.Fragment>
  );
};

export const CollectorDotEnv = ({ apiKey }) => {
  return (
    <CodeBlock language="bash">
      {`PGA_API_KEY=${apiKey || "your-organization-api-key"}
DB_HOST=ep-your-endpoint-id.your-region.aws.neon.tech
DB_NAME=your_database_name
DB_USERNAME=pganalyze
DB_PASSWORD=your_monitoring_user_password
DB_SSLMODE=require`}
    </CodeBlock>
  );
};

Create your configuration file (e.g. named `pganalyze_collector.env`) with environment variables like this:

<CollectorDotEnv apiKey={props.apiKey} />

Fill in the values step-by-step:

1. <APIKeyInstructions apiKey={props.apiKey} />
2. The `DB_HOST` is the compute endpoint hostname for the branch you want to monitor,
   of the form `ep-<endpoint-id>.<region>.aws.neon.tech`. You can copy the full
   connection string from the **Connect** dialog in the Neon Console for the branch
   in question
3. The `DB_NAME` is the database on that branch you want to monitor
4. The `DB_USERNAME` and `DB_PASSWORD` should be the credentials of the monitoring user
   we created in Step 1

The collector automatically detects that this is a Neon branch from the `DB_HOST` suffix
(`.neon.tech`), so no further platform-specific configuration is required. Note that Neon
doesn't expose host-level system metrics (CPU, memory, disk) through an API the collector
can use, so pganalyze will show query and schema statistics for your branch, but not the
System Overview metrics available for other platforms.

## Test snapshot

Then run the following:

```bash
docker run --env-file pganalyze_collector.env quay.io/pganalyze/collector:stable test
```

<PublicLastStepLogInsightsLink />
